import { environment } from '../../environments/environment';
// Ако още ползваш този трик с Subject/Observable от app.module – ОК,
// но по-правилно е: import { Observable } from 'rxjs/Observable';
import { Subject, Observable } from '../app.module';
import { LoginResponse } from '../beans/LoginResponse';
import { urlLinks } from '../utility/url-links';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injector, Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { StorageService } from './storage.service';

@Injectable()
export class AuthService implements CanActivate {

	constructor(
		private injector: Injector,
		private http: HttpClient,
		private storageService: StorageService
	) { }

	private get router(): Router {
		return this.injector.get(Router);
	}

	// 🔐 LOGIN (JWT / Bearer)
	login(username: string, password: string): Observable<LoginResponse> {

		const headers = new HttpHeaders().set('Content-Type', 'application/json');

		// изчистваме message-а за парола
		this.storageService.removePasswordMessage();

		return this.http.post<LoginResponse>(urlLinks.rest.user.logIn, { username, password }, { headers })
			.map((loginResponse: LoginResponse) => {

				this.storageService.setLoginResponse(loginResponse);
				this.storageService.setPasswordMessage(loginResponse.passwordExpiryMessageIfAny);

				return loginResponse;
			});
	}

	// 🔐 CHANGE PASSWORD (с Bearer токена)
	changePassword(password: string): Observable<any> {

		const authToken = this.storageService.getLoginResponse().token;

		const headers = new HttpHeaders({
			'Authorization': authToken ? 'Bearer ' + authToken : null,
			'Content-Type': 'application/json'
		});

		return this.http.post<LoginResponse>(
			urlLinks.rest.user.changePassword,
			{ password }, // body
			{
				headers,
				withCredentials: true
			}
		)
			.map((res: any) => {
				this.storageService.removePasswordMessage();
				return res;
			});
	}


	// 🚪 LOGOUT
	logout(): void {
		const authToken = this.storageService.getLoginResponse().token;

		this.http.post<any>(
			urlLinks.rest.user.signOff,
			{},
			{
				headers: new HttpHeaders({
					'Authorization': authToken ? 'Bearer ' + authToken : '',
					'Content-Type': 'application/json'
				}),
				withCredentials: true
			}
		).subscribe({
			next: () => {
				console.log('Logged out from backend');
			},
			error: err => {
				console.warn('Logout request failed:', err);
			}
		});

		this.storageService.removeLoginResponse();
		this.storageService.removePasswordMessage();
	}

	// ✅ CHECK LOGGED IN
	loggedIn(): boolean {
		return !!this.storageService.getLoginResponse().token;
	}

	// 🛡 GUARD
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (!this.loggedIn()) {
			this.router.navigateByUrl('/login');
			return false;
		}

		return true;
	}

	isUserAdmin(): boolean {
		return this.storageService.getLoginResponse().authority === 'ROLE_ADMIN';
	}

	getUserName() {
		return this.storageService.getLoginResponse().username;
	}
	getUserId() {
		return this.storageService.getLoginResponse().id;
	}

	getToken() { return this.storageService.getLoginResponse().token; }

}
